// extracted by mini-css-extract-plugin
export default {"actionButton":"Buttons_actionButton__vSTgn","defaultButton":"Buttons_defaultButton__3oeJI","saveButton":"Buttons_saveButton__RANxA"};